import { useId } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/modal';
import { FlexSpacer } from 'ui/flexSpacer';
import { PrimaryButton } from 'ui/button';
import { ENDPOINT_BLUEPRINTS } from '../constants';
import { EventUploaderForm } from './EventUploaderForm';
import { uploadEventRequest } from '../actions';
import {
  EventUploaderFormProvider,
  EventUploaderFormProviderType,
} from '../contexts/EventUploaderFormProvider';

type EventUploaderModalProps = {
  onClose: () => void;
};

export const EventUploaderModal = ({ onClose }: EventUploaderModalProps) => {
  const modalId = useId();
  const formId = useId();
  const dispatch = useDispatch();

  const onSubmit = ({ apiKey, endpoint, JSONsrc }: EventUploaderFormProviderType) => {
    dispatch(uploadEventRequest(apiKey, JSONsrc, endpoint));
    onClose();
  };

  return (
    <EventUploaderFormProvider
      defaultValues={{
        endpoint: 'users/update',
        JSONsrc: ENDPOINT_BLUEPRINTS['users/update'],
        apiKey: '',
      }}
    >
      <Modal id={modalId} isModalOpen onClose={onClose}>
        <ModalHeader>Create Demo Data</ModalHeader>
        <ModalBody>
          <FlexSpacer flexDirection="column" alignItems="stretch">
            <EventUploaderForm formId={formId} onSubmit={onSubmit} />
          </FlexSpacer>
        </ModalBody>
        <ModalFooter onClose={onClose}>
          <PrimaryButton data-test="upload-event-submit-button" type="submit" form={formId}>
            Create event
          </PrimaryButton>
        </ModalFooter>
      </Modal>
    </EventUploaderFormProvider>
  );
};
